import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import HourglassDisabledIcon from "@mui/icons-material/HourglassDisabled";
import MDButton from "components/MDButton";
import { useSession } from "context/SessionContext";
import logoutAndRedirect from "utils/logoutHelper";
import { useTranslation } from "hooks/useTranslation";

export default function SessionExpiredDialog() {
  const { sessionExpired, dismissSessionExpired } = useSession();
  const { t } = useTranslation();

  const handleLoginAgain = () => {
    dismissSessionExpired();
    logoutAndRedirect();
  };

  return (
    <Dialog
      open={sessionExpired}
      onClose={(_e, reason) => {
        // Don't allow dismissing by clicking outside or pressing Escape —
        // the user must explicitly confirm they want to log in again.
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, p: 1 },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "warning.light",
            color: "warning.dark",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HourglassDisabledIcon />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {t("auth.sessionExpired.title", "Session expired")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {t(
            "auth.sessionExpired.message",
            "Your session has expired for an inactivity on portal. Please log in again to continue."
          )}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <MDButton variant="gradient" color="info" fullWidth onClick={handleLoginAgain}>
          {t("auth.sessionExpired.loginAgain", "Log in again")}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
